/* eslint camelcase: "off" */
import React from "react"
import PropTypes from "prop-types"
import { FormContainer, InputField, StandardModal } from "uikit"
import { Grid, Form } from "semantic-ui-react"

const EmployerForm = ({
  data: {
    fields: { name, description },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Add This Employer",
  submitHeader = "",
  onCancel
}) => (
  <Form
    error={hasError}
    loading={isPending}
    className="AddModal__Form"
    onSubmit={onSubmit}
  >
    <Grid>
      <Grid.Row>
        <Grid.Column>
          <InputField
            autoFocus
            field={name}
            label="Name"
            className="AddModal__FormField"
            error={!!name.error}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <InputField
            field={description}
            label="Description (optional)"
            className="AddModal__FormField"
            error={description.error}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <button type="submit" style={{ display: "none" }} />
  </Form>
)

const AddEmployerFormModal = props => (
  <StandardModal defaultOpen={true} closeOnDimmerClick={false}>
    <StandardModal.Header header="Add Employer" />
    <StandardModal.Content>
      <EmployerForm {...props} />
    </StandardModal.Content>
    <StandardModal.Actions
      submitLabel="Add This Employer"
      cancelLabel="Cancel"
      onSubmit={props.data.onSubmit}
      onCancel={props.onCancel}
      loading={props.data.isPending}
    />
  </StandardModal>
)

export const EMPLOYER_SCHEMA = {
  name: {
    type: "string"
  },
  description: {
    type: "string",
    required: false
  }
}

export const AddEmployerModal = FormContainer(EMPLOYER_SCHEMA)(
  AddEmployerFormModal
)

AddEmployerModal.PropTypes = {
  submit: PropTypes.func,
  onCancel: PropTypes.func
}
